<div class="full-height full-width flex column align-center justify-center no-data">
  @if(_shopContext.currentShop() && !disableWelcome()) {
  <h2 class="margin-bottom">Welcome to {{_shopContext.currentShop()?.name}}</h2>
  }
  <h4 class="bold-text custom-margin">{{subTitle() || '- Page coming soon -'}}</h4>
  <img [class.small-image]="small()"
       src="assets/back-office/images/coming-soon-dark.svg">
</div>